export interface PurchaseItemReminder {
    type: string;
    sendReminderAt?: string;
    status: string;
}

export enum PurchaseItemReminderStatus {
    IGNORE = "ignore",
    ACTIVE = "active",
    IGNORE_SKIPPED = "ignore_skipped",
}